module.exports = __webpack_public_path__ + "img/astro7.dc1f75a1.jpg";